import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NotificationProvider, ToastProvider } from './features/notifications';
import { AuthProvider } from './features/auth/context/AuthContext';
import i18n from './i18n';
import { applyDocumentLocalization } from './shared/utils/localization';
import { completeMcpOAuthPopup } from './features/mcp/utils/mcpOAuthPopup';

// The OAuth callback lands in a popup; hand the result back and close without booting the app.
if (!completeMcpOAuthPopup()) {
  applyDocumentLocalization(i18n.resolvedLanguage);
  i18n.on('languageChanged', (language) => {
    applyDocumentLocalization(language);
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <AuthProvider>
      <NotificationProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </NotificationProvider>
    </AuthProvider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
